import React, { createContext, useContext } from 'react';
import useMalwareHook from '../../hooks/Dashboard/useMalware';

export const MalwareContext = createContext();

export const MalwareProvider = ({ children }) => {
  const web = useMalwareHook(); // Import everything from the hook

  return (
    <MalwareContext.Provider value={web}>
      {children}
    </MalwareContext.Provider>
  );
};

export const useMalware = () => useContext(MalwareContext);